import request from '@/apis';
import {
  Prize,
  PrizeType,
  RushGameInfo,
} from '@/components/features/casino/rush/types';

export const getRushGameInfo = () => {
  return request<RushGameInfo>({
    url: '/api/game/rush/v3/current-info',
    method: 'post',
  }).then((res) => res.data);
};

export interface RushBetParams {
  amount: number;
  currency: string;
}

export interface BetResponse {
  currentGamePoint: number;
  currentUserPoint: number;
  totalGamePoint: number;
  rushPoint: number;
  payout: number;
  rewardType: PrizeType;
  currency: string;
  amount: string;
  multiplier: string;
}

export const rushBet = (betParams: RushBetParams) => {
  return request<BetResponse>({
    url: '/api/game/rush/v3/bet',
    method: 'post',
    data: betParams,
  }).then((res) => {
    if (res.status.code === '0') {
      return res.data;
    } else {
      return null;
    }
  });
};

export const getUserRushBetRecords = (params: {
  currentPage: number;
  pageSize: number;
}) => {
  return request({
    url: '/api/game/rush/v3/user/reward-records',
    method: 'post',
    data: params,
  });
};

export const getRushAllBetRecords = (params: {
  currentPage: number;
  pageSize: number;
}) => {
  return request({
    url: '/api/game/rush/v3/bet-records',
    method: 'post',
    data: params,
  });
};

export const getRushOnlineUsers = (params: {
  currentPage: number;
  pageSize: number;
}) => {
  return request({
    url: '/api/game/rush/v3/online-user',
    method: 'post',
    data: params,
  });
};
